/**
 * Base validation configuration
 * Shared constants and patterns for Zod schema validation
 */

// String length constraints
export const STRING_LENGTHS = {
  NAME_MIN: 2,
  NAME_MAX: 100,
  DESCRIPTION_MAX: 500,
  LONG_DESCRIPTION_MAX: 1000,
  REASON_MIN: 10,
  REASON_MAX: 500,
  COST_CENTER_MIN: 5,
  COST_CENTER_MAX: 20,
  CATEGORY_MAX: 100
} as const

// Number constraints
export const NUMBER_CONSTRAINTS = {
  SALARY_MIN: 0,
  SALARY_MAX: 1000000,
  BUDGET_MIN: 0,
  BUDGET_MAX: 1000000000,
  PAYROLL_AMOUNT_MIN: -1000000,
  PAYROLL_AMOUNT_MAX: 1000000
} as const

// Date constraints
export const DATE_CONSTRAINTS = {
  MIN_YEAR: 1900,
  MIN_DATE: new Date('1900-01-01'),
  MAX_DATE: new Date()
} as const

// Regex patterns
export const PATTERNS = {
  // Brazilian phone: (XX) XXXXX-XXXX format (11 digits with formatting)
  PHONE: /^\(\d{2}\)\s\d{5}-\d{4}$/,

  // Alphanumeric with spaces and hyphens
  ALPHANUMERIC_EXTENDED: /^[a-zA-Z0-9\s-]+$/,

  // Alphanumeric only (for cost center codes)
  ALPHANUMERIC: /^[a-zA-Z0-9]+$/,

  // YYYY-MM format for payroll periods
  PERIOD_FORMAT: /^\d{4}-(0[1-9]|1[0-2])$/,

  // UUID format
  UUID: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,

  // ISO 8601 date format
  ISO_DATE: /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d{3})?(Z|[+-]\d{2}:\d{2})?)?$/
} as const

// Enums
export const ENUMS = {
  CONTRACT_TYPES: ['CLT', 'PJ', 'FREELANCER', 'INTERN'] as const,

  EMPLOYEE_STATUSES: ['ACTIVE', 'INACTIVE', 'PENDING', 'TERMINATED'] as const,

  ROLE_LEVELS: ['junior', 'mid', 'senior', 'lead', 'manager', 'director', 'executive'] as const,

  PAYROLL_TYPES: ['salary', 'bonus', 'overtime', 'commission', 'reimbursement', 'deduction', 'tax', 'benefit'] as const,

  CURRENCIES: ['BRL', 'USD', 'EUR'] as const
} as const

// Default values
export const DEFAULTS = {
  CURRENCY: 'BRL',
  EMPLOYEE_STATUS: 'ACTIVE',
  LIMIT: 20,
  DEBOUNCE_MS: 300
} as const
